import React from 'react';
import './Chapters.scss';

function Chapter11() {
  return (
    <section className="chapter">
      <h3 className="chapter__title">
        Taco Bell<sup>®</sup>: Reinventing Food Service with Digital Ordering
      </h3>
      <p className="chapter__paragraph">
        Every week,{' '}
        <a
          href="https://www.tacobell.com/"
          target="_blank"
          rel="sponsored"
          className="chapter__paragraph__link"
        >
          Taco Bell
        </a>{' '}
        serves more than 40 million customers from more than 7,000 restaurants in the U.S. Recently,
        there’s been a dramatic shift in how these customers want to order and receive their food.
        Instead of walking up to the counter and dining in the restaurant, many customers now prefer
        to receive their food from drive-thru service and deliveries. Or they expect to order in
        advance through an app, walk up to the counter, and have that food hot, ready, and waiting
        for customers or the delivery services they use to grab and go.
      </p>
      <p className="chapter__paragraph">
        To help address this fundamental change in behavior and make sure that customers could
        interact through multiple channels and touchpoints to get their food however and wherever
        they wish, Taco Bell turned to AWS infrastructure with Intel technology.
      </p>
      <p className="chapter__paragraph">
        In fact, thanks to its investments in AWS infrastructure with Intel technology, Taco Bell
        was well prepared when the COVID-19 pandemic accelerated the shift toward digital ordering
        and delivery apps. This preparation meant that Taco Bell had the technical capabilities to
        get its complex menu to delivery providers in real-time. This was crucial to making sure
        customers were able to get the chalupas, burritos, gorditas, and quesaritos they
        crave—however and whenever they want them.
      </p>
      <p className="chapter__paragraph">
        AWS infrastructure powered by Intel technology gives Taco Bell the flexibility, scalability,
        and reliability to match evolving customer preferences and accommodate unpredictable
        fluctuations in order volume. This allows Taco Bell to keep customers happy and protect its
        bottom line by fulfilling digital orders at scale in a timely way that keeps costs low.
      </p>
    </section>
  );
}

export default Chapter11;
